import { render, staticRenderFns } from "./salesDispatchManagement.vue?vue&type=template&id=962a6b4e&scoped=true"
import script from "./salesDispatchManagement.vue?vue&type=script&lang=js"
export * from "./salesDispatchManagement.vue?vue&type=script&lang=js"
import style0 from "./salesDispatchManagement.vue?vue&type=style&index=0&id=962a6b4e&prod&scoped=true&lang=css"
import style1 from "./salesDispatchManagement.vue?vue&type=style&index=1&id=962a6b4e&prod&lang=css"
import style2 from "./salesDispatchManagement.vue?vue&type=style&index=2&id=962a6b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962a6b4e",
  null
  
)

export default component.exports